import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import "bootstrap/dist/css/bootstrap.min.css";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { axiosNewInstance } from "../../config/Api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import LangData from "../common/LangData";

const Profile = () => {
  const user = useSelector((state) => state?.user);
  const loginUser = user?.loginuser || {};
  const [userProfile, setUserProfile] = useState({});
  const [roles, setRoles] = useState([]);
  const token = localStorage.getItem("authToken");

  useEffect(() => {
    fetchRoles();
    fetchProfile();
  }, []);

  const fetchRoles = async () => {
    try {
      if (!token) return;
      const response = await axiosNewInstance.post(
        "/api-app/get-roles",
        { is_paginate: "0" },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.status === 1 && response?.data?.data?.roles) {
        setRoles(response.data?.data?.roles);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const fetchProfile = async () => {
    try {
      if (!token) return;
      const response = await axiosNewInstance.post(
        "/api-app/get-user-profile",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === 1 && response.data.data.user) {
        setUserProfile(response.data.data.user);
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  const combinedUser = { ...loginUser, ...userProfile };

  const profileData = {
    id: combinedUser.id || "---",
    name: combinedUser.en_first_name || combinedUser.name || "---",
    email: combinedUser.email || "---",
    phone: combinedUser.mobile || "---",
    designation: combinedUser.designation || "---",
    role: roles.find((r) => Number(r.id) === Number(combinedUser.role_id))?.name || combinedUser.role_name || "---",
    branch: combinedUser.branch_code || "---",
  };

  return (
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-md-10 col-lg-8">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-primary text-white py-3 text-center">
              <h5 className="mb-0">
                <LangData keyname="label_profile" />
              </h5>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <tbody>
                    <tr>
                      <th className="bg-light w-30 py-3 pl-4 border-top-0">
                        <LangData keyname="label_name" />
                      </th>
                      <td className="py-3 pr-4 border-top-0 font-weight-bold text-dark">
                        {profileData.name}
                      </td>
                    </tr>
                    <tr>
                      <th className="bg-light w-30 py-3 pl-4">
                        <LangData keyname="label_customer_id" />
                      </th>
                      <td className="py-3 pr-4">{profileData.id}</td>
                    </tr>
                    <tr>
                      <th className="bg-light w-30 py-3 pl-4">
                        <LangData keyname="label_mobile" />
                      </th>
                      <td className="py-3 pr-4">{profileData.phone}</td>
                    </tr>
                    <tr>
                      <th className="bg-light w-30 py-3 pl-4">
                        <LangData keyname="label_policy_holder_email" />
                      </th>
                      <td className="py-3 pr-4">{profileData.email}</td>
                    </tr>
                    <tr>
                      <th className="bg-light w-30 py-3 pl-4">
                        <LangData keyname="label_designation" />
                      </th>
                      <td className="py-3 pr-4">{profileData.designation}</td>
                    </tr>
                    <tr>
                      <th className="bg-light w-30 py-3 pl-4">
                        <LangData keyname="label_role" />
                      </th>
                      <td className="py-3 pr-4">
                        <span className="badge badge-info px-3 py-2">
                          {profileData.role}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th className="bg-light w-30 py-3 pl-4">
                        <LangData keyname="label_branch_code" />
                      </th>
                      <td className="py-3 pr-4">{profileData.branch}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <style dangerouslySetInnerHTML={{
            __html: `
            .w-30 { width: 35%; }
            .card { border-radius: 12px; overflow: hidden; }
            .table th { font-weight: 600; color: #495057; border-right: 1px solid #dee2e6; }
            .table td { color: #6c757d; }
            .bg-primary { background: linear-gradient(135deg, #007bff 0%, #0056b3 100%) !important; }
            .badge-info { background-color: #e7f3ff; color: #007bff; border: 1px solid #b3d7ff; font-weight: 500; }
          `}} />
        </div>
      </div>
    </div>
  );
};

export default Profile;
